const initialState = {
  selectedMSISDN: '',
  selectedPlan: '',
  plans: [],
  selectedPlanPrice: 0,
};

export const pre2pos = {
  state: { ...initialState },
  reducers: {
    updateSelectedMSISDN(state, payload) {
      return {
        ...state,
        selectedMSISDN: payload,
      };
    },
    updateSelectedPlan(state, payload) {
      return {
        ...state,
        selectedPlan: payload,
      };
    },
    updatePlans(state, payload) {
      return {
        ...state,
        plans: payload,
      };
    },
    updateSelectedPlanPrice(state, payload) {
      return {
        ...state,
        selectedPlanPrice: payload,
      };
    },
    clearPlans() {
      return {
        ...initialState,
      };
    },
  },
};
